import styled from 'styled-components'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import Button from 'components/shared/Button'
import { useResolutions } from 'store/resolutions'
import { scrollTo } from 'helpers/animateScroll'
import { useAppDispatch } from 'store/hooks'
import { setIsCalendarOpened } from 'store/ticket-slice'

export const Wrapper = styled(Box)`
    border-radius: 8px;
`
export const NoTicketsTile = () => {
    const { isMobile } = useResolutions()
    const dispatch = useAppDispatch()

    const handleClick = () => {
        scrollTo({
            id: 'tickets-settings',
            duration: 500,
            isMobile,
        })
        dispatch(setIsCalendarOpened(true))
    }
    return (
        <Wrapper padding={[16, 32]} bgColor="grayscale_200" gap={24}>
            <Text variant="bodyLarge" color="grayscale_900">
                <FormattedMessage
                    id="tickets.no_tickets_message"
                    defaultMessage="Bilety online na ten dzień są niedostępne. Wybierz inną datę lub kup bilety na miejscu."
                />
            </Text>
            <Button onClick={handleClick} variant="borderPrimary">
                <FormattedMessage
                    id="global.btn.select_different_date"
                    defaultMessage="Wybierz inną datę"
                />
            </Button>
        </Wrapper>
    )
}
